var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28583 18.0925L4.42796 19.154L3.33252 15.3914L8.28583 18.0925Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3966 15.3914L19.2944 19.154L15.4365 18.0925L20.3966 15.3914Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.206 11.7035L15.6475 10.6625L16.8926 10.3359L19.206 11.7035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51611 11.7035L6.83628 10.3359L8.07461 10.6625L4.51611 11.7035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0741 10.5401L3.94482 9.7168L6.83652 10.336L4.0741 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6482 10.5401L16.8926 10.336L19.7775 9.7168L19.6482 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6482 10.5401L19.2059 11.7035L16.8926 10.3359L19.6482 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07373 10.5401L6.83615 10.3359L4.51599 11.7035L4.07373 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8926 10.3359L19.9612 9.02954L19.7775 9.71674L16.8926 10.3359Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83618 10.3359L3.94448 9.71674L3.76758 9.02954L6.83618 10.3359Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56494 5.73633H14.1576L13.1302 8.53277L9.56494 5.73633Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1302 8.53277H10.5923L9.56494 5.73633L13.1302 8.53277Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9614 9.02945L16.8928 10.3358L16.8384 6.82495L19.9614 9.02945Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07475 10.6624L6.83643 10.3358L6.88405 6.82495L8.07475 10.6624Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88381 6.82495L6.83618 10.3358L3.76758 9.02945L6.88381 6.82495Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8382 6.82495L16.8926 10.3358L15.6475 10.6624L16.8382 6.82495Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5923 8.53286L4.04688 3.6748L9.56492 5.73642L10.5923 8.53286Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6753 3.6748L13.1299 8.53286L14.1573 5.73642L19.6753 3.6748Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4365 18.0925L17.2396 15.3914H20.3966L15.4365 18.0925Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33252 15.3914H6.48958L8.28583 18.0925L3.33252 15.3914Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 12.2886L20.3968 15.3912H17.2398L16.7227 12.2886Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99988 12.2888L3.33252 15.3914L4.51642 11.7036L6.99988 12.2888Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48958 15.3912H3.33252L6.99988 12.2886L6.48958 15.3912Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 12.2888L19.2061 11.7036L20.3968 15.3914L16.7227 12.2888Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88379 6.82495L10.592 8.53276L8.07449 10.6624L6.88379 6.82495Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6474 10.6624L13.1299 8.53276L16.8381 6.82495L15.6474 10.6624Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2061 11.7035L19.6483 10.54L19.9885 10.785L19.2061 11.7035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51635 11.7035L3.73389 10.785L4.07409 10.54L4.51635 11.7035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6484 10.5401L19.7777 9.7168L20.1928 10.0434L19.6484 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07411 10.5401L3.52979 10.0434L3.94483 9.7168L4.07411 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40039 9.3017L3.76781 9.02954L3.94471 9.71674L3.40039 9.3017Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3222 9.3017L19.7778 9.71674L19.9615 9.02954L20.3222 9.3017Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51611 11.7036L8.07461 10.6626L6.99957 12.2888L4.51611 11.7036Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.206 11.7036L16.7225 12.2888L15.6475 10.6626L19.206 11.7036Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76779 9.02945L3.18945 6.25342L6.88403 6.82495L3.76779 9.02945Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8384 6.82495L20.533 6.25342L19.9614 9.02945L16.8384 6.82495Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07471 10.6626L10.5922 8.53296L10.8235 12.4589L8.07471 10.6626Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6477 10.6626L16.7228 12.2888L12.8989 12.4589L15.6477 10.6626Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8989 12.4589L13.1303 8.53296L15.6477 10.6626L12.8989 12.4589Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8234 12.4589L6.99951 12.2888L8.07454 10.6626L10.8234 12.4589Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6756 3.6748L20.533 6.25352L16.8384 6.82506L19.6756 3.6748Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04688 3.6748L10.5923 8.53286L6.88414 6.82506L4.04688 3.6748Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8381 6.82506L13.1299 8.53286L19.6753 3.6748L16.8381 6.82506Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88403 6.82506L3.18945 6.25352L4.04676 3.6748L6.88403 6.82506Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28551 18.0925L6.48926 15.3914L8.6053 15.4186L8.28551 18.0925Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4365 18.0925L15.1167 15.4186L17.2395 15.3914L15.4365 18.0925Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8988 12.4589H10.8236L10.5923 8.53296L12.8988 12.4589Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5923 8.53296H13.1302L12.8988 12.4589L10.5923 8.53296Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03408 18.7049L8.28564 18.0925L10.4289 19.1063L9.03408 18.7049Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2935 19.1063L15.4367 18.0925L14.6883 18.7049L13.2935 19.1063Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4153 18.4736L10.4289 19.1063L8.28564 18.0925L10.4153 18.4736Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3139 18.4736L15.4367 18.0925L13.2935 19.1063L13.3139 18.4736Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99956 12.2886L8.6053 15.4184L6.48926 15.3912L6.99956 12.2886Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2395 15.3912L15.1167 15.4184L16.7224 12.2886L17.2395 15.3912Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99951 12.2886L8.55082 13.8603L8.60526 15.4184L6.99951 12.2886Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7224 12.2886L15.1167 15.4184L15.1779 13.8603L16.7224 12.2886Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28564 18.0924L10.5922 16.9697L10.4153 18.4734L8.28564 18.0924Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4364 18.0924L13.3136 18.4734L13.1299 16.9697L15.4364 18.0924Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5922 16.9698L8.28564 18.0924L8.60543 15.4185L10.5922 16.9698Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1299 16.9698L15.1167 15.4185L15.4364 18.0924L13.1299 16.9698Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8989 12.4587L16.7228 12.2886L15.1783 13.8603L12.8989 12.4587Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55082 13.8603L6.99951 12.2886L10.8234 12.4587L8.55082 13.8603Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8233 12.4587L9.90478 13.2412L8.55078 13.8604L10.8233 12.4587Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1783 13.8604L13.8175 13.2412L12.8989 12.4587L15.1783 13.8604Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1167 15.4185L13.2524 14.4251L15.178 13.8604L15.1167 15.4185Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60521 15.4185L8.55078 13.8604L10.4695 14.4251L8.60521 15.4185Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4695 14.4251L8.55078 13.8604L9.90478 13.2412L10.4695 14.4251Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2524 14.4251L13.8172 13.2412L15.178 13.8604L13.2524 14.4251Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8175 13.2412L13.2527 14.4251L12.8989 12.4587L13.8175 13.2412Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90479 13.2412L10.8233 12.4587L10.4695 14.4251L9.90479 13.2412Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6882 18.7048L13.1641 19.7595L13.2933 19.1063L14.6882 18.7048Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M10.429 19.1063L10.5583 19.7595L9.03418 18.7048L10.429 19.1063Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2528 14.4251L12.8105 13.6971L12.899 12.4587L13.2528 14.4251Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4697 14.4251L10.8235 12.4587L10.912 13.6971L10.4697 14.4251Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8989 12.4587L12.8104 13.6971H10.9121L12.8989 12.4587Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9122 13.6971L10.8237 12.4587H12.899L10.9122 13.6971Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2524 14.425L15.1167 15.4184L13.1299 16.9697L13.2524 14.425Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5922 16.9697L8.60547 15.4184L10.4698 14.425L10.5922 16.9697Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4697 14.425L10.9188 16.7452L10.5922 16.9697L10.4697 14.425Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1303 16.9697L12.8037 16.7452L13.2528 14.425L13.1303 16.9697Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8105 13.697L13.2528 14.425L12.8037 16.7452L12.8105 13.697Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10.912 13.697L10.9188 16.7452L10.4697 14.425L10.912 13.697Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9121 13.697H12.8104L12.8036 16.7452L10.9121 13.697Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8036 16.7452H10.9189L10.9121 13.697L12.8036 16.7452Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3138 18.4734L13.2933 19.1062L13.1641 19.7593L13.3138 18.4734Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5584 19.7593L10.4291 19.1062L10.4155 18.4734L10.5584 19.7593Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4155 18.4734L10.5788 18.3237L10.5584 19.7594L10.4155 18.4734Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13.164 19.7594L13.1436 18.3237L13.3137 18.4734L13.164 19.7594Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5581 19.7594L10.5785 18.3237H13.1436L10.5581 19.7594Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1436 18.3237L13.164 19.7594H10.5581L13.1436 18.3237Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1299 16.9697L13.3136 18.4734L13.1435 18.3237L13.1299 16.9697Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5788 18.3237L10.4155 18.4734L10.5924 16.9697L10.5788 18.3237Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5922 16.9697L10.6943 17.2895L10.5786 18.3237L10.5922 16.9697Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1435 18.3237L13.0278 17.2895L13.1299 16.9697L13.1435 18.3237Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8985 17.0514L10.6943 17.2895L10.5923 16.9697L10.8985 17.0514Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1299 16.9697L13.0279 17.2895L12.8237 17.0514L13.1299 16.9697Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8241 17.0515L12.8037 16.7454L13.1303 16.9699L12.8241 17.0515Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5923 16.9699L10.9189 16.7454L10.8985 17.0515L10.5923 16.9699Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8036 16.7454L12.824 17.0515H10.8984L12.8036 16.7454Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 17.0515L10.9188 16.7454H12.8036L10.8984 17.0515Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 17.2896H13.0281L13.1438 18.3238L10.6943 17.2896Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1437 18.3238H10.5786L10.6943 17.2896L13.1437 18.3238Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 17.2897L10.8985 17.0515H12.824L10.6943 17.2897Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M12.824 17.0515L13.0281 17.2897H10.6943L12.824 17.0515Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9885 10.785L19.6483 10.54L20.1926 10.0433L19.7776 9.71676L20.3219 9.30171L19.9613 9.02955L20.5328 6.25352L19.6755 3.6748L14.1575 5.73642H9.5648L4.04676 3.6748L3.18945 6.25352L3.76779 9.02955L3.40038 9.30171L3.9447 9.71676L3.52965 10.0433L4.07397 10.54L3.73377 10.785L4.51623 11.7035L3.33234 15.3913L4.42778 19.1539L8.28565 18.0925L9.03409 18.7048L10.5582 19.7595H13.1641L14.6882 18.7048L15.4367 18.0925L19.2945 19.1539L20.3968 15.3913L19.2061 11.7035L19.9885 10.785Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28583 18.0925L4.42796 19.154L3.33252 15.3914L8.28583 18.0925Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3966 15.3914L19.2944 19.154L15.4365 18.0925L20.3966 15.3914Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M19.206 11.7035L15.6475 10.6625L16.8926 10.3359L19.206 11.7035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51611 11.7035L6.83628 10.3359L8.07461 10.6625L4.51611 11.7035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0741 10.5401L3.94482 9.7168L6.83652 10.336L4.0741 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6482 10.5401L16.8926 10.336L19.7775 9.7168L19.6482 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6482 10.5401L19.2059 11.7035L16.8926 10.3359L19.6482 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07373 10.5401L6.83615 10.3359L4.51599 11.7035L4.07373 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8926 10.3359L19.9612 9.02954L19.7775 9.71674L16.8926 10.3359Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83618 10.3359L3.94448 9.71674L3.76758 9.02954L6.83618 10.3359Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56494 5.73633H14.1576L13.1302 8.53277L9.56494 5.73633Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1302 8.53277H10.5923L9.56494 5.73633L13.1302 8.53277Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9614 9.02945L16.8928 10.3358L16.8384 6.82495L19.9614 9.02945Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07475 10.6624L6.83643 10.3358L6.88405 6.82495L8.07475 10.6624Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88381 6.82495L6.83618 10.3358L3.76758 9.02945L6.88381 6.82495Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8382 6.82495L16.8926 10.3358L15.6475 10.6624L16.8382 6.82495Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5923 8.53286L4.04688 3.6748L9.56492 5.73642L10.5923 8.53286Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6753 3.6748L13.1299 8.53286L14.1573 5.73642L19.6753 3.6748Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4365 18.0925L17.2396 15.3914H20.3966L15.4365 18.0925Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33252 15.3914H6.48958L8.28583 18.0925L3.33252 15.3914Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 12.2886L20.3968 15.3912H17.2398L16.7227 12.2886Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99988 12.2888L3.33252 15.3914L4.51642 11.7036L6.99988 12.2888Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48958 15.3912H3.33252L6.99988 12.2886L6.48958 15.3912Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 12.2888L19.2061 11.7036L20.3968 15.3914L16.7227 12.2888Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88379 6.82495L10.592 8.53276L8.07449 10.6624L6.88379 6.82495Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6474 10.6624L13.1299 8.53276L16.8381 6.82495L15.6474 10.6624Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2061 11.7035L19.6483 10.54L19.9885 10.785L19.2061 11.7035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51635 11.7035L3.73389 10.785L4.07409 10.54L4.51635 11.7035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6484 10.5401L19.7777 9.7168L20.1928 10.0434L19.6484 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07411 10.5401L3.52979 10.0434L3.94483 9.7168L4.07411 10.5401Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40039 9.3017L3.76781 9.02954L3.94471 9.71674L3.40039 9.3017Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3222 9.3017L19.7778 9.71674L19.9615 9.02954L20.3222 9.3017Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51611 11.7036L8.07461 10.6626L6.99957 12.2888L4.51611 11.7036Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M19.206 11.7036L16.7225 12.2888L15.6475 10.6626L19.206 11.7036Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76779 9.02945L3.18945 6.25342L6.88403 6.82495L3.76779 9.02945Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8384 6.82495L20.533 6.25342L19.9614 9.02945L16.8384 6.82495Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07471 10.6626L10.5922 8.53296L10.8235 12.4589L8.07471 10.6626Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6477 10.6626L16.7228 12.2888L12.8989 12.4589L15.6477 10.6626Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8989 12.4589L13.1303 8.53296L15.6477 10.6626L12.8989 12.4589Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8234 12.4589L6.99951 12.2888L8.07454 10.6626L10.8234 12.4589Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6756 3.6748L20.533 6.25352L16.8384 6.82506L19.6756 3.6748Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04688 3.6748L10.5923 8.53286L6.88414 6.82506L4.04688 3.6748Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8381 6.82506L13.1299 8.53286L19.6753 3.6748L16.8381 6.82506Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88403 6.82506L3.18945 6.25352L4.04676 3.6748L6.88403 6.82506Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28551 18.0925L6.48926 15.3914L8.6053 15.4186L8.28551 18.0925Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4365 18.0925L15.1167 15.4186L17.2395 15.3914L15.4365 18.0925Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8988 12.4589H10.8236L10.5923 8.53296L12.8988 12.4589Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5923 8.53296H13.1302L12.8988 12.4589L10.5923 8.53296Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03408 18.7049L8.28564 18.0925L10.4289 19.1063L9.03408 18.7049Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2935 19.1063L15.4367 18.0925L14.6883 18.7049L13.2935 19.1063Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4153 18.4736L10.4289 19.1063L8.28564 18.0925L10.4153 18.4736Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3139 18.4736L15.4367 18.0925L13.2935 19.1063L13.3139 18.4736Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99956 12.2886L8.6053 15.4184L6.48926 15.3912L6.99956 12.2886Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2395 15.3912L15.1167 15.4184L16.7224 12.2886L17.2395 15.3912Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99951 12.2886L8.55082 13.8603L8.60526 15.4184L6.99951 12.2886Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7224 12.2886L15.1167 15.4184L15.1779 13.8603L16.7224 12.2886Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28564 18.0924L10.5922 16.9697L10.4153 18.4734L8.28564 18.0924Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4364 18.0924L13.3136 18.4734L13.1299 16.9697L15.4364 18.0924Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5922 16.9698L8.28564 18.0924L8.60543 15.4185L10.5922 16.9698Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1299 16.9698L15.1167 15.4185L15.4364 18.0924L13.1299 16.9698Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8989 12.4587L16.7228 12.2886L15.1783 13.8603L12.8989 12.4587Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55082 13.8603L6.99951 12.2886L10.8234 12.4587L8.55082 13.8603Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8233 12.4587L9.90478 13.2412L8.55078 13.8604L10.8233 12.4587Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1783 13.8604L13.8175 13.2412L12.8989 12.4587L15.1783 13.8604Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1167 15.4185L13.2524 14.4251L15.178 13.8604L15.1167 15.4185Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60521 15.4185L8.55078 13.8604L10.4695 14.4251L8.60521 15.4185Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4695 14.4251L8.55078 13.8604L9.90478 13.2412L10.4695 14.4251Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2524 14.4251L13.8172 13.2412L15.178 13.8604L13.2524 14.4251Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8175 13.2412L13.2527 14.4251L12.8989 12.4587L13.8175 13.2412Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90479 13.2412L10.8233 12.4587L10.4695 14.4251L9.90479 13.2412Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6882 18.7048L13.1641 19.7595L13.2933 19.1063L14.6882 18.7048Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M10.429 19.1063L10.5583 19.7595L9.03418 18.7048L10.429 19.1063Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2528 14.4251L12.8105 13.6971L12.899 12.4587L13.2528 14.4251Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4697 14.4251L10.8235 12.4587L10.912 13.6971L10.4697 14.4251Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8989 12.4587L12.8104 13.6971H10.9121L12.8989 12.4587Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9122 13.6971L10.8237 12.4587H12.899L10.9122 13.6971Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2524 14.425L15.1167 15.4184L13.1299 16.9697L13.2524 14.425Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5922 16.9697L8.60547 15.4184L10.4698 14.425L10.5922 16.9697Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4697 14.425L10.9188 16.7452L10.5922 16.9697L10.4697 14.425Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1303 16.9697L12.8037 16.7452L13.2528 14.425L13.1303 16.9697Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8105 13.697L13.2528 14.425L12.8037 16.7452L12.8105 13.697Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M10.912 13.697L10.9188 16.7452L10.4697 14.425L10.912 13.697Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9121 13.697H12.8104L12.8036 16.7452L10.9121 13.697Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8036 16.7452H10.9189L10.9121 13.697L12.8036 16.7452Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3138 18.4734L13.2933 19.1062L13.1641 19.7593L13.3138 18.4734Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5584 19.7593L10.4291 19.1062L10.4155 18.4734L10.5584 19.7593Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4155 18.4734L10.5788 18.3237L10.5584 19.7594L10.4155 18.4734Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M13.164 19.7594L13.1436 18.3237L13.3137 18.4734L13.164 19.7594Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5581 19.7594L10.5785 18.3237H13.1436L10.5581 19.7594Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1436 18.3237L13.164 19.7594H10.5581L13.1436 18.3237Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1299 16.9697L13.3136 18.4734L13.1435 18.3237L13.1299 16.9697Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5788 18.3237L10.4155 18.4734L10.5924 16.9697L10.5788 18.3237Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5922 16.9697L10.6943 17.2895L10.5786 18.3237L10.5922 16.9697Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1435 18.3237L13.0278 17.2895L13.1299 16.9697L13.1435 18.3237Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8985 17.0514L10.6943 17.2895L10.5923 16.9697L10.8985 17.0514Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1299 16.9697L13.0279 17.2895L12.8237 17.0514L13.1299 16.9697Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8241 17.0515L12.8037 16.7454L13.1303 16.9699L12.8241 17.0515Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5923 16.9699L10.9189 16.7454L10.8985 17.0515L10.5923 16.9699Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8036 16.7454L12.824 17.0515H10.8984L12.8036 16.7454Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 17.0515L10.9188 16.7454H12.8036L10.8984 17.0515Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 17.2896H13.0281L13.1438 18.3238L10.6943 17.2896Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1437 18.3238H10.5786L10.6943 17.2896L13.1437 18.3238Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 17.2897L10.8985 17.0515H12.824L10.6943 17.2897Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M12.824 17.0515L13.0281 17.2897H10.6943L12.824 17.0515Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9f13371904189f5471b79d3850e8a864.svg";
export { ForwardRef as ReactComponent };